import { Box, HStack, Header, Icon, Pressable, Text, VStack } from '@rbilabs/universal-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';
import { ProgressMeter } from 'components/progress-meter';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';
import { nullNoop } from 'utils/noop';

import { HIGHLIGHT_COLOR } from '../constants';

export const REWARD_CARD_HEIGHT = 140;

export const RewardText = Header.withConfig({
  variant: 'headerThree',
  marginBottom: '$1',
  ellipsizeMode: 'tail',
  numberOfLines: 2,
});

export const BackgroundImage = Picture.withConfig({
  width: '100%',
  height: '100%',
  position: 'absolute',
});

export const StyledProgressMeter = ProgressMeter.withConfig({
  width: '90%',
  borderWidth: 0,
  background: 'white',
});

export const StyledRewardPoints = Text.withConfig({
  fontSize: 'md',
  textTransform: 'lowercase',
});

export const CardContainer = Box.withConfig({
  height: `${REWARD_CARD_HEIGHT}px`,
  bgColor: primitive.$white,
});

export const StyledClickableContainer = Pressable.withConfig<{ isLocked: boolean }>({
  flexDirection: 'row',
  height: '100%',
  textAlign: 'left',
  backgroundColor: Styles.color.white,
  borderBottomWidth: 1,
  borderBottomColor: Styles.color.grey.four,
  padding: '$4',
});

export const ImageWrapper = Box.withConfig({
  width: '120px',
  flexShrink: 0,
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '$2',
});

export const InfoContainer = VStack.withConfig({
  marginLeft: '$0.5',
  flexGrow: 1,
  justifyContent: 'center',
  paddingLeft: '$2',
});

export const StyledLockIcon = nullNoop;

export const PointsNeededContainer = HStack.withConfig({
  marginTop: '$2',
  space: 1,
});

export const PointsNeededText = Text.withConfig({
  fontSize: 'sm',
});

export const PointsNeededTextDetail = Text.withConfig({
  color: Styles.color.primary,
});

export const PointTextContainer = HStack.withConfig({
  space: 1,
  marginBottom: '$2',
  alignItems: 'center',
});

export const StyledPointsText = Text.withConfig({
  fontSize: 'sm',
  lineHeight: 'md',
});

export const StyledPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '24px',
  height: '24px',
});

export const StyledUnLockedRewardPoints = Box.withConfig({
  display: 'none',
});

export const StyledRewardLock = Icon.withConfig({
  variant: 'locked',
  size: 12,
});

export const PointsNeededLockIcon = StyledRewardLock.withConfig({
  display: 'none',
  size: '$5',
  color: HIGHLIGHT_COLOR,
});

export const IncentiveCardDescription = SanityBlockRenderer.withConfig({
  width: 'full',
  overflow: 'hidden',
  mb: '$2',
  textProps: {
    numberOfLines: 2,
    fontSize: 12,
    lineHeight: 16,
    ellipsizeMode: 'tail',
  },
});
